// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__328Kr","right":"styles_right__2eB3w"};